import Vuetify from "../../plugins/vuetify";
import Constants from "../../constants/Constants";
import axios from "axios";
import i18n from "../../i18n";

const namespaced = true;

const state = {
  appName: Constants.APPLICATION.GET_APP_NAME(),
  darkMode: true,
  logo: Constants.APPLICATION.LOGO,
  logoDarkMode: Constants.APPLICATION.LOGO_DARK_MODE,
  copyrights: Constants.COPYRIGHTS.GET_COPYRIGHTS(),
  sideNavigation: false,
  menuItems: [],
  color: undefined,
  github: Constants.GITHUB,
  backend: Constants.BACKEND,
  viewComponents: Constants.APPLICATION.VIEW_COMPONENTS,
  utils: Constants.UTILS,
  locale: Constants.LOCALE,
  appBar: {},
};

const getters = {
  appName(state) {
    return state.appName;
  },
  backend(state) {
    return state.backend;
  },
  locale(state) {
    return state.locale;
  },
  github(state) {
    return state.github;
  },
  githubProjects(state) {
    return state.github.projects;
  },
  color(state) {
    return state.color;
  },
  logo(state) {
    return state.logo;
  },
  logoDarkMode(state) {
    return state.logoDarkMode;
  },
  darkMode(state) {
    return state.darkMode;
  },
  copyrights(state) {
    return state.copyrights;
  },
  appBar(state) {
    return state.appBar;
  },
  menuItems(state) {
    return state.menuItems;
  },
  utils(state) {
    return state.utils;
  },
  viewComponents(state) {
    return state.viewComponents;
  },
};

const mutations = {
  setDarkMode(state, payload) {
    state.darkMode = payload;
  },
  setColor(state, payload) {
    state.color = payload;
  },
  setAppBar(state, payload) {
    state.appBar = payload;
  },
  setMenuItems(state, payload) {
    state.menuItems = payload;
  },
  addMenuItem(state, payload) {
    state.menuItems.push(payload);
  },
  setGithubProjects(state, payload) {
    state.github.projects = payload;
  },
  setLocale(state, payload) {
    state.locale = payload;
  },
};

const actions = {
  darkMode({ commit }, payload) {
    Vuetify.framework.theme.isDark = payload;
    Vuetify.framework.theme.dark = payload;
    commit("setDarkMode", payload);
  },
  locale({ commit }, payload) {
    i18n.locale = payload;
    commit("setLocale", payload);
  },
  createMenuItem(_, payload) {
    const str = payload[0];
    const i = payload[1];
    return {
      id: `${str.replace(/ /g, "")}${i}`,
      lbl: `${str} ${i}`,
      path: `../${str.replace(/ /g, "")}`,
      name: `${str.replace(/ /g, "")}`,
    };
  },
  loadColorFromVuetify({ commit }) {
    if (this.state.settings.darkMode === true) {
      commit("setColor", Vuetify.framework.theme.themes.dark);
    } else {
      commit("setColor", Vuetify.framework.theme.themes.light);
    }
  },
  setPrimarycolor({ commit }, payload) {
    if (this.state.settings.darkMode === true) {
      Vuetify.framework.theme.themes.dark.primary = payload.hex;
      commit("setPrimaryColor", Vuetify.framework.theme.themes.dark.primary);
    } else {
      Vuetify.framework.theme.themes.light.primary = payload.hex;
      commit("setPrimaryColor", Vuetify.framework.theme.themes.light.primary);
    }
  },
  loadGithubProjects({ commit }) {
    //dispatch("loading/setLoading", true, { root: true });
    const githubProjects = this.state.settings.github.repos.split(" ");
    const arr = [];
    for (let i = 0; i < githubProjects.length; i++) {
      const repo = {
        name: "",
        description: "",
        commits: [],
      };
      const e = githubProjects[i];
      axios
        .get(this.state.settings.github.GET_API_REPO_URL(e))
        .then((res) => {
          repo.name = res.data.name;
          repo.description = res.data.description;
        })
        .catch((err) => {
          console.log("Error:", err);
        });

      axios
        .get(this.state.settings.github.GET_API_COMMITS_URL(e))
        .then((res) => {
          return res.data;
        })
        .then((commits) => {
          let amount = commits.length;
          for (let index = 0; index < commits.length; index++) {
            amount -= 1;
            const commit = commits[index].commit;

            const c = {
              date: commit.author.date,
              name: "Author: " + commit.author.name,
              comment: "Comment: " + commit.message,
              value: amount,
            };

            repo.commits.push(c);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
      arr.push(repo);
    }
    commit("setGithubProjects", arr);
    //dispatch("loading/setLoading", false, { root: true });
  },
  async createMenuItems({ commit, getters }) {
    const arr1 = getters.viewComponents;
    const arr2 = [];
    let int = 1;
    for (let i = 0; i < arr1.length; i++) {
      const item = arr1[i];
      const e = await this.dispatch("settings/createMenuItem", [
        item.name,
        int,
      ]);
      arr2.push(e);
      int++;
    }
    commit("setMenuItems", arr2);
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
